import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "mfa-success-container" }
const _hoisted_2 = { class: "uk-grid" }
const _hoisted_3 = { class: "uk-width-1-2 uk-margin-top" }
const _hoisted_4 = { class: "uk-width-1-1 uk-margin-top uk-text-small" }
const _hoisted_5 = { id: "button-container" }

import Input from '@/components/Input.vue'
import { ref } from 'vue'
import Typography from '@/components/Rain/Typography/Typography.vue'

interface Props {
    onBack: Function
    onSubmit: Function
}

export default /*@__PURE__*/_defineComponent({
  __name: 'MFAVerifyRecoveryCode',
  emits: ['onBack', 'onSubmit'],
  setup(__props, { emit: __emit }) {

const emit = __emit
const recoveryCode = ref('')

const sendRecoveryCode = () => {
    emit('onSubmit', recoveryCode.value)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[4] || (_cache[4] = _createElementVNode("div", { class: "uk-width-1-2" }, [
        _createElementVNode("img", {
          src: "/img/login/mfa-key.svg",
          width: "37",
          height: "39",
          alt: "success-icon"
        })
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(Typography, {
          variant: "h4",
          component: "h4",
          class: "title-container"
        }, {
          default: _withCtx(() => _cache[2] || (_cache[2] = [
            _createTextVNode("Verify Recovery Code")
          ]), undefined, true),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_4, [
        _cache[3] || (_cache[3] = _createElementVNode("p", null, [
          _createTextVNode(" Please enter one of your "),
          _createElementVNode("strong", null, "recovery codes.")
        ], -1)),
        _createVNode(Input, {
          ref: "recoveryCodeInput",
          modelValue: recoveryCode.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((recoveryCode).value = $event)),
          class: "codeInput",
          title: "Enter your recovery code",
          placeholder: "Enter your recovery code",
          maxlength: 13,
          required: true,
          "err-msg": 'Please enter your recovery code'
        }, null, 8, ["modelValue"])
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("a", {
        class: "button uk-button",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('onBack')))
      }, "Back"),
      _createElementVNode("a", {
        class: "uk-button button primary",
        onClick: sendRecoveryCode
      }, "Submit")
    ])
  ]))
}
}

})